/**
 * Algorithm used for encryption.
 */
export const securePassEncrypter = '286b88f2ceb76ce1e7d28117bb2a7659'
